export default "__VITE_ASSET__98476147__"